import { Pipe, PipeTransform } from '@angular/core';

import { UnidadeNegocioNaturezaVenda } from '../unidade-negocio-natureza-venda';

@Pipe({
    name: 'unidadeNegocioNaturezaVendaSituacaoFilter',
    pure: false
})
export class UnidadeNegocioNaturezaVendaSituacaoFilterPipe implements PipeTransform {
    /** Filtra as naturezas de vendas pela situação informada */
    transform(entities: UnidadeNegocioNaturezaVenda[], situacao: number = null): UnidadeNegocioNaturezaVenda[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as naturezas de vendas quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.naturezaVenda?.situacao === situacao);
    }
}
